import { useNavigate, useParams } from "react-router-dom";

import {
  type GetOrganizationUsersOutput,
  type GetOrganizationsOutput,
  useBasecampOrganizationUsersRetrieve,
  useBasecampOrganizationsRetrieve,
} from "@api/rest/types-and-hooks";

import { AddEditUser } from "./AddEditUser";

export const UserDetail: React.FC = () => {
  const { orgId, userId } = useParams<{ orgId: string; userId: string }>();
  const navigate = useNavigate();

  const { data: orgData } = useBasecampOrganizationsRetrieve({ id: orgId }, { query: { enabled: !!orgId } });

  const {
    data: userData,
    isLoading: userLoading,
    refetch: refetchUser,
  } = useBasecampOrganizationUsersRetrieve(
    { organization_id: orgId!, auth0_id: userId },
    { query: { enabled: !!orgId && !!userId } },
  );

  const org: GetOrganizationsOutput | undefined =
    orgData?.status === 200
      ? Array.isArray(orgData.data)
        ? orgData.data.find((o) => String(o.id) === orgId)
        : orgData.data
      : undefined;

  const user: GetOrganizationUsersOutput | undefined =
    userData?.status === 200 ? (Array.isArray(userData.data) ? userData.data[0] : userData.data) : undefined;

  if (!org || userLoading) return null;

  return (
    <AddEditUser
      organization={org}
      user={user}
      onCancel={() => navigate(`/organizations/${orgId}`)}
      onSuccess={() => refetchUser()}
    />
  );
};
